<template>
  <v-btn
    rounded
    :outlined="outlined"
    color="primary"
    :disabled="disabled"
    :loading="loading"
    v-bind="$attrs"
    v-on="$listeners"
    :min-width="minWidth"
  >
    {{ buttonName }}
  </v-btn>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ButtonDefault',
  props: {
    buttonName: {
      type: String,
      required: true
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: '100%'
    }
  }
})
</script>
